import { Box, Card, styled, useMediaQuery, useTheme } from '@mui/material';
import { H5 } from 'components/Typography';

const PaymentHistoryCard = ({ ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Sample payment history data
  const paymentHistory = [
    {
      id: 1,
      date: '2025년 10월 10일',
      content: '커뮤니티 VIP 멤버쉽',
      amount: '19,900원',
    },
    {
      id: 2,
      date: '2025년 10월 10일',
      content: '커뮤니티 VIP 멤버쉽',
      amount: '19,900원',
    },
    {
      id: 3,
      date: '2025년 10월 10일',
      content: '커뮤니티 VIP 멤버쉽',
      amount: '19,900원',
    },
  ];

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    backgroundColor: theme.palette.primary.lightGrey200,
    borderRadius: 0,
    border: 'none',
  }));

  const TableHeader = styled(Box)(({ theme }) => ({
    backgroundColor: '#F8F8F8',
    borderRadius: '8px',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '8px',
  }));

  const HeaderColumn = styled(Box)(({ theme, align = 'left' }) => ({
    fontSize: '14px',
    fontWeight: '500',
    color: '#6B7280',
    textAlign: align,
    flex: align === 'right' ? '0 0 120px' : '1',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      flex: align === 'right' ? '0 0 100px' : '1',
    },
  }));

  const TransactionRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '12px 16px',
    borderBottom: '1px solid #F3F4F6',
    '&:last-child': {
      borderBottom: 'none',
    },
  }));

  const TransactionColumn = styled(Box)(({ theme, align = 'left' }) => ({
    fontSize: '14px',
    fontWeight: '400',
    color: '#1F2937',
    textAlign: align,
    flex: align === 'right' ? '0 0 120px' : '1',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      flex: align === 'right' ? '0 0 100px' : '1',
    },
  }));

  return (
    <StyledCard
      sx={{
        border: 'none',
        overflow: 'visible',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: '#fff',
            padding: isMobile ? '18px' : '26px',
            borderRadius: '24px',
            boxShadow: '1px 4px 6px rgba(0, 0, 0, 0.05)',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Title */}
          <Box
            sx={{
              marginBottom: '24px',
            }}
          >
            <H5
              sx={{
                fontWeight: 'bold',
                lineHeight: 1.3,
                fontSize: isMobile ? '16px' : '18px',
                color: '#1F2937',
              }}
            >
              결제 내역
            </H5>
          </Box>

          {/* Payment History Table */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            {/* Table Header */}
            <TableHeader>
              <HeaderColumn>날짜</HeaderColumn>
              <HeaderColumn>내용</HeaderColumn>
              <HeaderColumn align="right">금액</HeaderColumn>
            </TableHeader>

            {/* Transaction Rows */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {paymentHistory.map((transaction, index) => (
                <TransactionRow key={transaction.id}>
                  <TransactionColumn>{transaction.date}</TransactionColumn>
                  <TransactionColumn>{transaction.content}</TransactionColumn>
                  <TransactionColumn align="right">
                    {transaction.amount}
                  </TransactionColumn>
                </TransactionRow>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default PaymentHistoryCard;
